import { useEffect, useState } from "react";
import configCatClient, { ConfigCatUser } from ".";

export const useGetConfigCatValue = (
  key: string,
  defaultValue?: any,
  user?: ConfigCatUser
) => {
  const [value, setValue] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getFlag = async () => {
      setIsLoading(true);

      const response = await configCatClient.getValueAsync(
        key,
        defaultValue,
        user
      );

      setValue(response);
      setIsLoading(false);
    };
    getFlag();
  }, [user?.email, user?.identifier]);

  return [value, isLoading];
};

export const useGetConfigCatValueMap = (
  flags: string[],
  defaultValue?: any,
  user?: ConfigCatUser
): [keyValues: Record<string, boolean>, isLoading: boolean] => {
  const [values, setValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getFlag = async () => {
      setIsLoading(true);

      const values = {};
      for await (const flag of flags) {
        const response = await configCatClient.getValueAsync(
          flag,
          defaultValue,
          user
        );

        values[flag] = response;
      }

      setValues(values);
      setIsLoading(false);
    };

    getFlag();
  }, [user?.email, user?.identifier]);

  return [values, isLoading];
};
